<template>
  <div class="neutral">
    <div class="ui inverted fixed menu">
      <a
        v-show="isLogged"
        @click.prevent="toggleMenu"
        id="toogle-menu"
        class="item"
        title="Menu"
      >
        <i class="bars icon"></i> Menu
      </a>
      <div class="fluid item">
        <router-link to="/">ClubOn</router-link>
      </div>
      <div class="right menu">
        <div v-show="isLogged" class="ui dropdown item">
          <i class="user circle icon"></i>
          <span class="mobile hidden">{{ user }}</span>
          <i class="dropdown icon"></i>
          <div class="menu">
            <a class="item" @click.prevent="logout">Sair</a>
          </div>
        </div>
      </div>
    </div>
    <Sidebar ref="sidebar" />
  </div>
</template>
<script type="text/javascript">
import { mapState, mapGetters } from 'vuex';
import Sidebar from './widgets/Sidebar';

export default {
  components: { Sidebar },
  data() {
    return {
      showSidebar: false
    };
  },

  computed: {
    ...mapState({
      user: state => state.user.user.name
    }),

    ...mapGetters({
      isLogged: 'user/isLogged'
    })
  },

  mounted() {
    $(this.$el).find('.dropdown').dropdown();
  },

  methods: {
    logout() {
      this.$store.commit('user/logout');
    },

    toggleMenu() {
      this.$refs.sidebar.toggle();
    }
  }
};
</script>

<style lang="css" scoped>
.ui.menu {
  margin: 0px;
  height: var(--user-menu-height);
  background: var(--dark-bg-color);
  z-index: 1000 !important;
}
.ui.menu > .item:first-child {
  justify-content: center;
}
.ui.text.menu .dropdown.item .user.icon {
  font-size: 2rem;
}
.item {
  min-width: 60px;
}
.right.menu {
  min-width: 60px;
}

.fluid.item {
  flex: 1;
  justify-content: center;
}
</style>
